const intFormat = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export function formatInt(value: number | null | undefined): string {
  return value == null ? "—" : intFormat.format(value);
}

export function formatMinutes(seconds: number): string {
  return `${intFormat.format(Math.round(seconds / 60))} min`;
}

export function formatDuration(seconds: number | null): string {
  if (seconds == null || !isFinite(seconds)) return "—";
  const total = Math.round(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function formatUsd(value: number | null | undefined, small = false): string {
  if (value == null) return "—";
  const digits = small && Math.abs(value) < 1 ? 4 : 2;
  return `$${value.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
}

export function formatPercent(value: number | null | undefined): string {
  return value == null || !isFinite(value) ? "—" : `${value.toFixed(1)}%`;
}

export function formatLatency(ms: number | null | undefined): string {
  return ms == null ? "—" : `${(ms / 1000).toFixed(2)} s`;
}

export function ratio(part: number, whole: number): number | null {
  return whole > 0 ? (part / whole) * 100 : null;
}
